import ApiService from "@/core/services/ApiService";

class FormService {

    public static getForm(tag: any, slug: any){
        ApiService.setHeader()
        return ApiService.get(`api/forms/${tag}`, slug)
    }

    public static saveForm(tag: any, data: any){
        ApiService.setHeader()
        return ApiService.post(`api/forms/${tag}`, data)
    }

    public static editParticipate(id: any){
        ApiService.setHeader()
        return ApiService.get(`api/forms/${id}`, 'edit-participate')
    }

    public static options(slug: any, data: any){
        ApiService.setHeader()
        return ApiService.post(`api/forms/${slug}`, data)
    }
}

export default FormService;